import { render, staticRenderFns } from "./GalleryFiles.component.vue?vue&type=template&id=36dbcfd3&scoped=true&"
import script from "./GalleryFiles.component.vue?vue&type=script&lang=js&"
export * from "./GalleryFiles.component.vue?vue&type=script&lang=js&"
import style0 from "./GalleryFiles.component.vue?vue&type=style&index=0&id=36dbcfd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dbcfd3",
  null
  
)

export default component.exports